module.exports = __webpack_public_path__ + "media/assets/good_at/ionic-3d611f08170887dae95fa5bda304fd4d.png";